import currentReqTypes from "./currentReq.types";

export const fetchCurrentCardStart = () => ({
  type: currentReqTypes.FETCH_CURRENTREQ_START,
});

export const fetchCurrentCardSuccess = (info) => ({
  type: currentReqTypes.FETCH_CURRENTREQ_SUCCESS,
  payload: info,
});

export const fetchCurrentCardBitsStart = () => ({
  type: currentReqTypes.FETCH_CURRENTREQBITS_START,
});

export const fetchCurrentCardBitsSuccess = (bits) => ({
  type: currentReqTypes.FETCH_CURRENTREQBITS_SUCCESS,
  payload: bits,
});

export const fetchLoadLocationStart = () => ({
  type: currentReqTypes.FETCH_LOADLOACTION_START,
});

export const fetchLoadLocationSuccess = (data) => ({
  type: currentReqTypes.FETCH_LOADLOCATION_SUCCESS,
  payload: data,
});

export const clearCurrentCard = () => ({
  type: currentReqTypes.CLEAR_CURRENTREQ,
});

// async
let counter_fetchCurrentCardAsync = 0;
export const fetchCurrentCardAsync = (socket, id) => async (
  dispatch,
  getState
) => {
  //   alert("hi");
  await dispatch(fetchCurrentCardStart());

  // console.log(getState().currentReq.isLoading);
  // alert("sdfsd");

  socket.emit("get_loads", {
    filter: { id },
  });

  if (counter_fetchCurrentCardAsync++ !== 0) return;

  socket.on("response_loads", async (data) => {
    // debugger;
    // console.log(currentReq_Isloading);
    if (!getState().currentReq.isLoading) return;
    // alert(data.length !== 1);
    // if (data.length !== 1) return;
    // alert(2);
    // debugger;

    // console.log("123123", data);
    if (data.length < 1) {
      // alert("hi");
      return;
    }

    dispatch(fetchCurrentCardSuccess(data[0]));

    dispatch(fetchCurrentCardBitsStart());
    socket.emit("get_bits", { load_id: data[0].id });

    // dispatch(fetchAllReqsSuccess(data));
  });

  // alert("emited");

  socket.on("response_bits", (data) => {


    // setBits(data);
    dispatch(fetchCurrentCardBitsSuccess(data));
    // setIsloading(false);
  });
};

let counter_fetchLoadLocationAsync = 0;
export const fetchLoadLocationAsync = (socket, driver, load_id) => (
  dispatch
) => {
  dispatch(fetchLoadLocationStart());

  socket.emit("get_driver_location", {
    driver,
    load_id,
  });

  if (counter_fetchLoadLocationAsync++ !== 0) return;
  socket.on("my_loads_location", (data) => {
    // alert("resp");
    console.log(data);
    dispatch(fetchLoadLocationSuccess(data));

    // alert("new location");
    // updateNextPageMap(data);
  });
};
